<!--/**
 * Componente Vue para visualizar una tabla con la informacion que le sea otorgada, esta informacion puede ser un JSON con datos a paginar,
 * un simple Array o un String (url) con el recurso a consumir.
 * 
 * Los datos a retornar por el recurso deben de terner la siguiente estructua.
 * Ejemplo A:
 * {
 *     "next": "http://url/api/resource/?page=2",    # next String Link con link siguiente, o null en caso de no tener.
 *     "previous": null,                             # previous String Link con link anteriror, o null en caso de no tener.
 *     "num_pages": 3,                               # num_pages Number Numero de paginas.
 *     "current_page": 1,                            # current_page Number Con la pagina actual.
 *     "count": 5,                                   # count Number Con la cantidad de registros.
 *     "results": [                                  # results Array<Object> con los resultados de la busqueda.
 *         {
 *              "url": "http://url/api/resource/1/", # url String, con la url hacia cada elemento de la lista.
 *              "first_name": "Jonathan",
 *              "last_name": "Espinal",
 *          },
 *          {
 *              "url": "http://url/api/resource/2/",
 *              "first_name": "Andres",
 *              "last_name": "Ramirez",
 *          }
 *      ]
 * }
 * 
 * 
 * @version 1.0.0
 * @author Jonathan Andres Espinal Ramirez.
 * @since 2017-03-05
 * @param items JSON con los nombres de los campos, label y datos adicionales que se va a mostrar en el grid
 * Ejemplo B:
 * [
 *     {
 *         name: 'first_name',         # name String Nombre del campo que viene en el recurso.
 *         label: 'Nombres',           # label String Nombre del campo para la cabecera de la tabla.
 *         ordering: true,             # ordering Boolean Indica si se puede o no ordenar por este campo.
 *         filters: ['exact', {        # filters Array<String | Object> Filtros que se pueden aplicar. Si este parametro es String admite: (exact, icontains, contains, range, in, gte, lte, gt, lt, custom)
 *             name: 'icontains',      # name String Tipo de filtro. Este parametro admite: (exact, icontains, contains, range, in, gte, lte, gt, lt, custom)
 *             label: 'Puede contener' # label String Texto a mostrar para el tipo de filtro.
 *          }]
 *      }
 * ]
 *
 * En el caso de que se requieran listas desplegables los datos a retornar por el recurso deben de terner la siguiente estructura .
 * Ejemplo C:
 *   'name': {
 *       'object': 'unit',
 *       'key': 'name'
 *   },
 *   'label': 'Unidad',
 *   'ordering': true,
 *   'filters': ['exact', {
 *       'name': 'icontains',
 *       'label': 'Puede contener'
 *   }]
 *
 * @param resource String con la url de recurso a consumir.
 * @param errorMessage String de error al momento de fallar la carga de un recurso.
 * @param previousButtonText String con el texto para el boton "Anterior" del boton de la paginacion.
 * @param nextButtonText String con el texto para el boton "Siguiente" del boton de la paginacion.
 * @param paginationPlace String para indicar la posicion de la paginacion. Este parametro admite: (TOP, BOTTOM, BOTH)
 * @param searchDisplay Boolean permite visualizar el formulario de busqueda por defecto esta en falso para tener oculto el formulario
 * @param edit String con la url del Componente de edicion
 * @param deleteUrl String con la url del servicio para eliminar
 * @param btnDetail Bolean que indica si se debe visualizar la columna de ver detalle por defecto esta en false
 * @param btnDelete Bolean que indica si se debe visualizar la columna de elimina por defecto esta en true
 * @param btnEdit Bolean que indica si se debe visualizar la columna de editar por defecto esta en true
 * @param slot (header) HTML con la cabecera del grid.
 * @param slot (footer) HTML con el pie del grid.
 * @depends js/vue/loading, js/vue/vue-resource, css/fonts/dededed.ttf
 */-->
<template>
    <span>
        <slot name="header"></slot>
        <slot>
        <hr />
        <div id="search_form">
            <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                    <div class="panel-heading text-right">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="javascript:;" v-on:click="searchDisplay = !searchDisplay" id="btn-search"><span class="glyphicon glyphicon-search"></span> Buscar</a>
                        </h4>
                    </div>
                    <div id="collapse1" v-show="searchDisplay" >
                        <div class="panel-body">
                            <div class="row">
                                <div v-for="item in items" v-if="item.filters" class="col-md-3">
                                    <label class="control-label col-md-12">{{ item.label }}</label>
                                        <div class="col-md-6">
                                            <select v-model="filter[item.filterName].name" class="form-control">
                                                <option v-bind:value="getFilter(filter, 'name')"
                                                        v-for="filter in item.filters">{{ getFilter(filter, 'label') }}</option>
                                            </select>
                                        </div>
                                    
                                        <div class="col-md-6">
                                            <span v-if="item.filterList">
                                                <select v-model="filter[item.filterName].value" class="form-control">
                                                    <option></option>
                                                    <option v-for="choice in item.filterList" v-bind:value="choice.value">{{ choice.label }}</option>
                                                </select>
                                            </span>
                                            
                                            <span v-else>
                                                <input type="text" v-model="filter[item.filterName].value" class="form-control"/>
                                            </span>
                                        </div>
                                </div>
                                <div class="clearfix"></div><br>
                                <button v-on:click="getData(resource)" class="btn btn-success center-block">Buscar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="gridHideControlls">
            <input type="hidden" v-model="ordering">
        </span>
        
        <span v-if="paginationPlace === 'TOP' || paginationPlace === 'BOTH'">
            <button v-bind:disabled="pagination.previous === null" v-on:click="getData(pagination.previous)">{{ previousButtonText }}</button>
            <button v-bind:disabled="pagination.next === null" v-on:click="getData(pagination.next)">{{ nextButtonText }}</button>
            Página: {{ pagination.currentPage }} de {{ pagination.numPages }} -- (Total: {{ pagination.count }})
        </span>
        <div class="table-responsive">
            <table class="table table-striped"> 
                <thead>
                    <tr>
                        <th v-for="item in items" v-if="item.showGrid !== false">
                            <span class="column-ordering">
                                            <i v-show="ordering === item.name" class="fa fa-sort-asc" aria-hidden="true"></i>
                                            <i v-show="ordering === '-' + item.name" class="fa fa-sort-desc" aria-hidden="true"></i>
                                        </span>
                            <a href="javascript:"
                            v-if="item.ordering"
                            v-on:click="setOrdering(item.name)">{{ item.label }}</a>
                            <span v-else>{{ item.label }}</span>
                        </th>
                        <th v-if="btnDetail===true">Ver detalle</th>
                        <th v-if="btnEdit===true">Editar</th>
                        <th v-if="btnDelete===false">Eliminar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingError">
                        <td v-bind:colspan="items.length">
                            {{ errorMessage }}
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-else-if="isLoading">
                        <td v-bind:colspan="items.length">
                            <emt-loading></emt-loading>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-else v-for="element in data">
                        <td v-for="item in items" v-if="item.showGrid !== false">
                            <div v-if="getTypeof(element[item['name']]) == 'boolean'">
                                <div v-if="element[item['name']]"><span class="glyphicon glyphicon-ok"></span></div>
                                <div v-else></div>
                            </div>
                            <div v-else-if="getTypeof(item['name']) == 'string'">
                                {{ element[item['name']] }}
                            </div>
                            <div v-else-if="getTypeof(item['name']) == 'date'">
                                {{ element[item['name']].substring(0,19).replace('T',' ') }}
                            </div>
                            <div v-else-if="getTypeof(item['name']) == 'object'">
                                <span v-if="typeof(element[item['name']['object']][0])!=='undefined'">{{ element[item['name']['object']][0][item['name']['key']] }}</span>
                                <span v-else>{{ element[item['name']['object']][item['name']['key']] }}</span>
                            </div>
                        </td>
                        <td v-if="btnDetail===true"><router-link v-bind:to="edit+element['id']"><span class="glyphicon glyphicon-eye-open"></span></router-link></td>
                        <td v-if="btnEdit===true"><router-link v-bind:to="edit+element['id']"><span class="glyphicon glyphicon-edit"></span></router-link></td>
                        <td v-if="btnDelete===false"><a v-on:click="removeRegister(element['id'])"><span class="glyphicon glyphicon-trash"></span></a></td>
                    </tr>
                    <tr v-if="data.length === 0">
                        <td v-bind:colspan="items.length">
                            No se encontraron datos...
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <span v-if="paginationPlace === 'BOTTOM' || paginationPlace === 'BOTH'">
            <div class="col-xs-6 col-md-6">
                Página: {{ pagination.currentPage }} de {{ pagination.numPages }} -- (Total: {{ pagination.count }})
            </div>
            <div class="col-xs-6 col-md-6 text-right">
                <button v-bind:disabled="pagination.previous === null" v-on:click="getData(pagination.previous)" class="btn-previous">{{ previousButtonText }}</button>
                <button v-bind:disabled="pagination.next === null" v-on:click="getData(pagination.next)" class="btn-next">{{ nextButtonText }}</button>
            </div>
        </span>
        </slot>
        <slot name="footer"></slot>
    </span>
</template>

<script>
// import Cookies from 'js-cookie'
import EmtLoading from '@/components/emt-loading'
import swal from 'sweetalert2'

export default{
    name: 'emt-grid',
    data: function () {
        return {
            filterTypes: {
                exact: 'Exacto',
                contains: 'Contiene',
                icontains: 'Contiene',
                range: 'Rango'
            },
            filter: {},
            ordering: '',
            isLoading: false,
            loadingError: false,
            data: [],
            searchDisplay: false,
            pagination: {
                currentPage: null,
                numPages: null,
                count: null,
                previous: null,
                next: null
            },
            sourceFilter: null
        }
    },
    props: {
        resource: String,
        edit: String,
        deleteUrl: String,
        items: Array,
        btnEdit: {
            type: Boolean,
            default: true
        },
        btnDelete: {
            type: Boolean,
            default: true
        },
        btnDetail: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        previousButtonText: {
            type: String,
            default: 'Anterior'
        },
        nextButtonText: {
            type: String,
            default: 'Siguiente'
        },
        paginationPlace: {
            type: String,
            default: 'BOTTOM',
            validator: function (value) {
                if (value !== 'TOP' && value !== 'BOTTOM' && value !== 'BOTH') {
                    return false
                }
                return true
            }
        },
        source: String
    },
    methods: {

        /**
         * se utiliza para consultar y retornar el tipo de dato que se envia a la funcion
         */
        getTypeof: function (value) {
            if (value === 'created_at') {
                return 'date'
            }
            return typeof value
        },
        /**
         * Toma una url y le agrega los filtros y el ordenamiento.
         * Para ello toma la informacion del atributo this.filter.
         * Para mapear la url, se debe saber si esta url ya contiene algun query string y pregunta por el atributo search del elemento a (link)
         * en caso de no tener, se agrega el query string iniciando por el caracter "?" en caso contrario con el caracter "&"
         * @param url String con la url a mapear.
         * @return String con la url mapeada.
         */
        parseUrl: function (url) {
            let parser = document.createElement('a')
            parser.href = url
            // Preguntar si la url ya tiene algun query string...
            if (this.getTypeof(this.ordering) === 'object') {
                this.ordering = this.ordering.object
            }
            if (parser.search === '' || parser.search === null) {
                url += '?ordering=' + this.ordering + '&'
            } else {
                url += '&ordering=' + this.ordering + '&'
            }
            // Recorrer los filtros y agregarlos nuevo query string, el formato es:
            // <campo a filtrar>__<tipo filtro>=<valor a buscar>
            // Ejemplo 1: age__gt=18 (Edades mayores a 18)
            // Ejemplo 2: id__in=1,2,3,4 (Los id iguales a 1, 2, 3 y 4)
            // Ejemplo 3: date_year__range=2010,2017 (Los años de una fecha que esten entre 2010 y 2017)
            // Ejemplo 4: first_name=Jonathan (El nombre sea igual a Jonathan) Para el tipo de filtro "exact" no se usa first_name__exact solo se deja first_name
            // if (localStorage.getItem('filter')) {
            //     // se obtiene la cookie el filtro anterior
            //     // this.filter = JSON.parse(localStorage.getItem('filter'))
            //     localStorage.setItem('filter', JSON.stringify(this.filter))
            // }
            if (localStorage.getItem('filter') && this.sourceFilter === 'consult') {
                // localStorage.setItem('filter', JSON.stringify(this.filter))
                let changeFilter = false
                for (var i in this.filter) {
                    if (this.filter[i].value !== null) {
                        changeFilter = true
                        break
                    }
                }
                if (!changeFilter) {
                    this.filter = JSON.parse(localStorage.getItem('filter'))
                }
            }
            for (var filter in this.filter) {
                if (this.filter[filter].value === null) continue
                if (this.filter[filter].name === 'exact') {
                    if (filter === 'reason' || filter === 'subreason' || filter === 'channel' || filter === 'unit' || filter === 'area' || filter === 'user_assigned' || filter === 'company' || filter === 'company') {
                        url += filter + '__name' + '=' + this.filter[filter].value + '&'
                    } else if (filter === 'status_display') {
                        url += 'status' + '=' + this.filter[filter].value + '&'
                    } else {
                        url += filter + '=' + this.filter[filter].value + '&'
                    }
                } else {
                    if (filter === 'reason' || filter === 'subreason' || filter === 'channel' || filter === 'unit' || filter === 'area' || filter === 'user_assigned' || filter === 'company') {
                        url += filter + '__name' + '__' + this.filter[filter].name + '=' + this.filter[filter].value + '&'
                    } else if (filter === 'account') {
                        url += filter + '__document' + '=' + this.filter[filter].value + '&'
                        // url += filter + '__surname' + '=' + this.filter[filter].value + '&'
                    } else {
                        url += filter + '__' + this.filter[filter].name + '=' + this.filter[filter].value + '&'
                    }
                }
            }
            if (this.sourceFilter === 'consult') {
                localStorage.setItem('filter', JSON.stringify(this.filter))
            }
            return url
        },

        /**
         * Es usado para ejecutar un order by por alguno de los campos.
         * Para filtrar se hace primero en order ascendente, luego en orden descendente agregnando el caracter "-" al inicio del string
         * y por ultimo se deja de ordenar.
         * Ejemplo 1:
         * Se tiene la columna "name", si se hace click en esta, el recurso debera ordenar por "name", se hace click de nuevo en la misma coluna,
         * el recurso ordenara por "-name", si se hace click de nuevo en la misma columna se dejara de ordenar.
         * @see Documentacion general (param > items > ordering) Ejemplo B.
         * @param value String por el cual se quiere filtrar, aqui se envia el nombre de la columna.
         * @return void
         */
        setOrdering: function (value) {
            if (this.getTypeof(value) === 'object') {
                value = value.object
            }
            if (value === 'status_display') {
                value = 'status'
            }
            if (value === this.ordering) {
                this.ordering = '-' + value
            } else {
                if ('-' + value === this.ordering) {
                    this.ordering = ''
                } else {
                    this.ordering = value
                }
            }
            this.getData(this.resource)
        },

        /**
         * Si el recurso va a paginar resultados, es necesario mostrar esta paginacion en el cliente.
         * @see Documentacion general Ejemplo A.
         * @param pagination JSON con la estructura de la paginacion y los datos.
         * @return void
         */
        setPagination: function (pagination) {
            this.setData(pagination.results)
            this.pagination.currentPage = pagination['current_page']
            this.pagination.numPages = pagination['num_pages']
            this.pagination.count = pagination['count']
            this.pagination.previous = pagination['previous']
            this.pagination.next = pagination['next']
        },

        /**
         * Asigna la informacion a mostrar en la el Grid.
         * @param data Array<JSON> con la informacion a mostrar.
         * @return void
         */
        setData: function (data) {
            this.data = data
        },

        /**
         * Ejecuta el recurso para traer la informacion del servidor.
         * Antes de ir a servidor, primero se modifica la url en caso de tener filtro u ordenamiento.
         * @see vue-resource
         * @param url String con la recurso a consumir.
         * @return void
         */
        getData: function (url) {
            url = this.parseUrl(url)
            let self = this
            self.isLoading = true
            self.$http.get(url).then(function (response) {
                self.setPagination(response.body)
                self.isLoading = false
                self.loadingError = false
                if (self.searchDisplay) {
                    self.searchDisplay = !self.searchDisplay
                }
            }, function (response) {
                self.loadingError = true
                self.isLoading = false
            })
        },
        getFilter: function (filter, type) {
            switch (typeof filter) {
            case 'string':
                if (type === 'name') return filter
                if (type === 'label') return this.filterTypes[filter]
                break
            case 'object':
                if (type === 'name') {
                    return filter.name
                }
                if (type === 'label') {
                    if (typeof (filter.label) === 'undefined') {
                        return this.filterTypes[filter.name]
                    }
                    return filter.label
                }
                break
            }
        },
        reload: function () {
            this.getData(this.resource)
        },
        removeRegister: function (id) {
            var url = this.deleteUrl + id + '/'
            let self = this
            swal({
                title: '¿Desea eliminar este registro?',
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                cancelButtonText: 'No'
            }).then(function () {
                self.$http.delete(url).then(function (response) {
                    swal({
                        title: 'Se eliminó el registro exitosamente',
                        text: '',
                        type: 'success',
                        confirmButtonText: 'Aceptar'
                    })
                    this.getData(this.resource)
                }, function (response) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: 'No se pudo eliminar el registro.',
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                })
            })
        }
    },
    watch: {
        resource: function (url) {
            this.getData(url)
        }
    },
    created: function () {
        for (var item in this.items) {
            for (var filter in this.items[item].filters) {
                this.items[item].filterName = (typeof (this.items[item].filterName) === 'undefined') ? this.items[item].name : this.items[item].filterName
                this.items[item].filterName = this.items[item].filterName.object || this.items[item].filterName
                let defaultFilterName = this.items[item].filters[filter].name || this.items[item].filters[filter]
                this.filter[this.items[item].filterName] = {
                    name: defaultFilterName,
                    value: null
                }
                break
            }
        }
        this.sourceFilter = this.source
        this.getData(this.resource)
    },
    components: {
        'emt-loading': EmtLoading
    },
    mounted: function () {
        // localStorage.setItem('filter', JSON.stringify(this.filter))
        this.getData(this.resource)
    }
}
</script>



// WEBPACK FOOTER //
// emt-grid.vue?6da0222b